import React, { useState, useEffect } from 'react';
import { useAppDispatch, useAppSelector } from '../../../../redux/hooks';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

// Components 
import { Box, Grid, Typography } from '@mui/material';
import DataBox from '../../../general/data/DataBox';
import InfoRow from '../../../general/inputs/InfoRow';
import Button from '../../../general/inputs/Button';
import { setDashboardSection } from '../../../../redux/features/general/navigation';
import moment from 'moment';

interface Props { 

}; 

const Subscription: React.FC<Props> = ({ }) => {
    const dispatch = useAppDispatch(); 
    const { t } = useTranslation(); 
    const navigate = useNavigate(); 

    const colors = useAppSelector(state => state.theme.colors); 
    const subscription = useAppSelector(state => state.billing.subscription); 
    const nextInvoicePreview = useAppSelector(state => state.billing.nextInvoicePreview); 

    const [startDate, setStartDate] = useState(''); 
    const [endDate, setEndDate] = useState(''); 

    useEffect(() => { 

        if (subscription) { 

            if (subscription?.status === 'trialing') { 

                setStartDate(moment.unix(subscription?.trial_start).utc(true).format('LL')); 
                setEndDate(moment.unix(subscription?.trial_end).utc(true).format('LL')); 

            } else { 

                setStartDate(moment.unix(subscription?.items.data[0]?.current_period_start).utc(true).format('LL')); 
                setEndDate(moment.unix(subscription?.items.data[0]?.current_period_end).utc(true).format('LL')); 
            }; 
        };

    },[subscription]); 

    return (
        <DataBox>
            {/* This InfoRow correctly places the title */}
            <InfoRow 
                title={String(t('planDetails'))}
                extraStyle={{ '&:hover': { backgroundColor: 'transparent', cursor: 'default' }}}
                isDisabled
            />

            <InfoRow 
                title={String(t('medcaProMonthly'))}
                titleStyle={{ fontWeight: 'bold', fontSize: 18 }}
                extraStyle={{ '&:hover': { backgroundColor: 'transparent', cursor: 'default' }, mb: 2 }}
                isDisabled
            />

            {/* Responsive Grid Layout for details */}
            <Grid container spacing={2} sx={{ width: '100%', textAlign: 'center', color: colors?.text }}>
                <Grid item xs={6} sm={3}>
                    <Typography variant="caption">{String(t('startDate'))}</Typography>
                    <Typography sx={{ fontWeight: 'bold', fontSize: 14 }}>{startDate}</Typography>
                </Grid>
                <Grid item xs={6} sm={3}>
                    <Typography variant="caption">
                        {`${(subscription?.status === 'trialing') ? `${String(t('freeTrial'))} ` : '' }${String(t('endsOn'))}`}
                    </Typography>
                    <Typography sx={{ fontWeight: 'bold', fontSize: 14 }}>{endDate}</Typography>
                </Grid>
                <Grid item xs={6} sm={3}>
                    <Typography variant="caption">{String(t('currentPlan'))}</Typography>
                    <Typography variant="body1" fontWeight="bold" sx={{ color: 'darkblue' }}>{String(t('pro'))}</Typography>
                </Grid>
                <Grid item xs={6} sm={3}>
                    <Typography variant="caption">{String(t('nextInvoice'))}</Typography>
                    <Typography variant="body1" fontWeight="bold">
                        ${nextInvoicePreview ? (nextInvoicePreview.amount_remaining / 100).toFixed(2) : '0.00'}
                    </Typography>
                </Grid>
            </Grid>
        </DataBox>
    );
};

export default Subscription;